import React, { useEffect, useState } from "react";
import { ApiService } from "../../components/Common/ApiService";
import { isIdTarget } from "../../store/actions/todoActions";

import { LazyLoadImage } from "react-lazy-load-image-component";
import { useDispatch } from "react-redux";
import ConditionalRender from "../../components/Common/ConditionalRender";
import { formatRupiah, useHandleClickLoading } from "../../components/Common/utils";
import { ReactComponent as DescIcon } from "../../assets/icon/descicon.svg";
import { ReactComponent as SaldoKeluarIcon } from "../../assets/icon/saldo_keluar.svg";
import { ReactComponent as SaldoMasukIcon } from "../../assets/icon/saldo_masuk.svg";

import EditProfile from "./EditProfile";
import GiftCard from "./GiftCard";
import TopupSaldo from "./TopupSaldo";

import { ReactComponent as LinkIcon } from "../../assets/icon/link.svg";
import ListPoint from "./ListPoint";
import Button from "../../components/Common/Button";

function ProfilePages() {
    const isLogin = localStorage.getItem("isLogin");
    const parseLogin = JSON.parse(isLogin);
    const isProfile = localStorage.getItem("isProfile");
    const profileData = JSON.parse(isProfile);
    const [selectedButton, setSelectedButton] = useState("Topup");
    const [historyTransactionData, setHistoryTransactionData] = useState([]);
    const [historyTransactionLoading, setHistoryTransactionLoading] = useState(true);

    const status = localStorage.getItem('isChoosePage');
    const dispatch = useDispatch();
    const handleClickLoading = useHandleClickLoading();

    useEffect(() => {
        setSelectedButton(status)
    }, [status]);

    useEffect(() => {
        if (isLogin) {
            fetchDataHistoryTransaction(parseLogin?.apiKey, parseLogin?.token);
        }
        dispatch(isIdTarget(undefined));
    }, [dispatch]);

    const fetchDataHistoryTransaction = async (api_key, token) => {
        setHistoryTransactionLoading(true);
        try {
            const params = new URLSearchParams();
            params.append("api_key", api_key);

            const response = await ApiService({
                baseurl: "user/historiOrder?limit",
                method: "POST",
                XGORDON: "HISTORIORDER",
                apiKey: api_key,
                token: token,
                body: params,
            });
            setHistoryTransactionLoading(false);
            if (response?.statusCode === 200) {
                setHistoryTransactionData(response.result.data);
            } else {
                setHistoryTransactionData([]);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    return (
        <div className="flex flex-col gap-3 p-2 flex-1">
            <div className="flex md:flex-row flex-col gap-3 px-2 ">
                <div className="flex flex-col gap-3 flex-1 ">
                    {selectedButton === "EditProfile" && <EditProfile />}
                </div>
                <div className=" flex-col gap-2 basis-1/3 md:flex hidden relative ">

                    <div className="flex flex-col rounded-lg relative shadow-inner bg-cardLight dark:bg-cardDark">
                        <div className="flex  flex-col flex-1 gap-2 justify-end p-3">
                            <div className=" flex  gap-2 flex-row items-center justify-between pb-2 border-b border-[#f3f3f3]">
                                <span className="text-sm opacity-50 font-medium line-clamp-1">
                                    Saldo Saya
                                </span>
                                <div className="flex flex-row gap-1">
                                    <span className=" text-base font-bold line-clamp-1">
                                        {formatRupiah(profileData?.saldo)}
                                    </span>
                                    <Button
                                        initialValue="Log Saldo"
                                        type="fill"
                                        className="bg-[#22BDE2] text-darkColor h-6 text-[9px]"
                                        onClick={() => {
                                            handleClickLoading('/logsaldo')
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-1 overflow-hidden rounded-md">
                                <div className="flex flex-row items-center justify-center flex-1 gap-3 bg-[#C8E6C9] p-2.5">
                                    <SaldoMasukIcon fill="#4CAF50" />
                                    <span className=" text-sm font-medium line-clamp-1 text-[#4CAF50]">
                                        {formatRupiah(profileData?.penambahan_saldo)}
                                    </span>
                                </div>
                                <div className="flex flex-row items-center justify-center flex-1 gap-3 bg-[#FFCDD2] p-2.5">
                                    <SaldoKeluarIcon fill="#F44336" />
                                    <span className=" text-sm font-medium line-clamp-1 text-[#F44336] ">
                                        {formatRupiah(profileData?.pengurangan_saldo)}
                                    </span>
                                </div>
                            </div>
                            <div className="flex flex-row gap-2 items-center">
                                <DescIcon className="w-5 h-5 " fill="#2196F3" />
                                <span className=" text-xs flex-1">
                                    Riwayat saldo direset perbulan
                                </span>
                            </div>
                            <div className=" flex  gap-2 flex-row items-center justify-between pt-2 border-t border-[#f3f3f3]">
                               <div className="flex flex-col gap-1">
                               <span className="text-sm opacity-50 font-medium line-clamp-1">
                               Point Saya
                                </span>
                                <span className=" text-base font-bold line-clamp-1">
                                  {profileData?.poin} Pts
                                </span>
                               </div>
                                <Button
                                    initialValue="Tukar Poin"
                                    type="fill"
                                    className="bg-[#22BDE2] text-darkColor h-6 text-[9px]"
                                    onClick={() => {
                                        handleClickLoading('/tukarpoin')
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col rounded-lg sticky top-3 shadow-inner  bg-cardLight dark:bg-cardDark overflow-hidden">
                        <div className="flex flex-row justify-between gap-1 rounded-tl-md  rounded-tr-md p-3 z-10">
                            <span className="text-base font-medium line-clamp-1">
                                Riwayat Transaksi
                            </span>
                            <button onClick={() => { handleClickLoading('/history-order') }}>
                                <LinkIcon className="w-4 h-4 " fill="#22BDE2" />
                            </button>
                        </div>
                        <div className="flex flex-col gap-2 p-3 pt-0 z-10">
                            <ConditionalRender
                                productsData={historyTransactionData}
                                isLoading={historyTransactionLoading}
                                model={"emptyData"}
                            >
                                {historyTransactionData.map((item, index) => (
                                    <button key={index}
                                        onClick={() => handleClickLoading('/invoice/' + item.invoice)}>
                                        <div
                                            className="flex flex-col rounded-lg p-2 gap-2 backdrop-blur-lg bg-[#d9d9d932] h-full justify-between shadow-inner "
                                        >
                                            <div className="flex flex-row justify-between items-center =">

                                                <span className=" text-xs font-light line-clamp-1 ">
                                                    {item.tanggal}
                                                </span>
                                                <div className="flex flex-row items-center gap-1">
                                                    <div className={`rounded-sm text-darkColor ${item.status === "cancel"
                                                        ? " bg-[#F42536]"
                                                        : item.status === "refund"
                                                            ? "  bg-[#ED610A]"
                                                            : item.status === "pending"
                                                                ? " bg-[#ED610A]"
                                                                : item.status === "paid"
                                                                    ? " bg-[#ED610A]"
                                                                    : item.status === "not_paid"
                                                                        ? " bg-[#000000]"
                                                                        : item.status === "processing"
                                                                            ? " bg-[#3694ff]"
                                                                            : item.status === "success"
                                                                                ? " bg-[#0ABE5D]"
                                                                                : null
                                                        } p-1`}>

                                                        <span className={` text-[10px] line-clamp-1`}>
                                                            {item.status}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex flex-row justify-between items-center =">
                                                <div className="flex flex-row gap-2 items-center flex-1">
                                                    {item.gambar && <div >
                                                        <LazyLoadImage
                                                            src={item.gambar}
                                                            alt={item.layanan}
                                                            className=" object-cover  sm:h-20 h-16 aspect-square rounded-lg"
                                                            effect="blur"
                                                        />
                                                    </div>}
                                                    <div className="flex flex-col flex-1 items-start">
                                                        <span className=" text-xs font-light line-clamp-1 ">
                                                            {item.invoice}
                                                        </span>
                                                        <span
                                                            className={` text-sm font-bold text-left`}
                                                        >
                                                            {item.layanan}
                                                        </span>
                                                        <span className={` font-light text-sm text-left `}>
                                                            {item.kategori}
                                                        </span>
                                                        <span className=" text-sm text-[#22BDE2] font-semibold line-clamp-1 ">
                                                            {formatRupiah(item.harga)}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </button>
                                ))}
                            </ConditionalRender>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default ProfilePages;
